import React, { useState } from 'react';

export const EMPTY_STUDENT = { last_name: '', first_name: '', room: '', bed: '', departure: '', class_name: '', floor: '' };
const FIELDS = [
  ['room', 'Chambre', 'Ex. 115'],
  ['bed', 'Lit', 'A ou B'],
  ['last_name', 'Nom', ''],
  ['first_name', 'Prénom', ''],
  ['departure', 'Départ', 'JJ.MM.AAAA'],
  ['class_name', 'Classe', 'Facultatif'],
  ['floor', 'Étage', 'Facultatif'],
];
const inputClass = 'h-11 w-full rounded-md border border-input bg-background px-3 text-base min-[1025px]:text-sm';

/** Fiche étudiant (ajout ou modification), partagée entre l'administration et l'onglet agent. */
const StudentForm = ({ initial, onSubmit, onCancel, busy, label, testId = 'student-form' }) => {
  const [values, setValues] = useState({ ...EMPTY_STUDENT, ...(initial || {}) });
  return (
    <form
      onSubmit={(event) => { event.preventDefault(); onSubmit(values); }}
      className="grid grid-cols-2 gap-3 rounded-lg border border-primary/40 p-3 sm:grid-cols-4"
      data-testid={testId}
    >
      {FIELDS.map(([field, title, placeholder]) => (
        <label key={field} className={field === 'last_name' || field === 'first_name' ? 'col-span-2 sm:col-span-1' : ''}>
          <span className="mb-1 block text-xs font-semibold text-muted-foreground">{title}{field === 'room' ? ' *' : ''}</span>
          <input
            value={values[field] || ''}
            onChange={(event) => setValues((previous) => ({ ...previous, [field]: event.target.value }))}
            placeholder={placeholder}
            data-testid={`student-${field}`}
            className={inputClass}
          />
        </label>
      ))}
      <div className="col-span-2 flex flex-col gap-2 sm:col-span-4 sm:flex-row">
        <button type="submit" disabled={busy} className="h-11 rounded-md bg-primary px-5 font-semibold text-primary-foreground disabled:opacity-60" data-testid="student-save">
          {label}
        </button>
        <button type="button" onClick={onCancel} className="h-11 rounded-md border border-border px-5">Annuler</button>
      </div>
    </form>
  );
};

export default StudentForm;
